import React from "react";
import classes from "./RoundedCard.module.scss";
import classnames from "classnames";
import { RoundedCardProps } from "components/v2/Cards/RoundedCard/types/RoundedCardProps";

const RoundedCard: React.FC<RoundedCardProps> = ({
  icon,
  customStyles,
  onClick,
}) => {
  return (
    <div
      className={classnames(classes["rounded-card"], customStyles)}
      onClick={onClick}
    >
      {icon}
    </div>
  );
};
export default RoundedCard;
